import { composeCouponRouteTemplate } from '@/lib/coupon/gen-code'
import { DEFAULT_PERCENTAGE_COUPON } from '@/providers/coupon/PercentageFormProvider'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/coupon/percentage')(
  composeCouponRouteTemplate(DEFAULT_PERCENTAGE_COUPON),
)
